export default "__VITE_ASSET__CGObmi38__"